import { createContext } from "react";
import type { AppState, AppAction } from "./appTypes";

export type AppContextType = {
  state: AppState;
  dispatch: React.Dispatch<AppAction>;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

